import { portalAction, portalScreenContext, trackPortalEvent } from '../../../../app/telemetry/portalTelemetry';
import { usePortalScreen } from '../../../../app/telemetry/usePortalTelemetry';
import { Button, Grid } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../../app/store/configureStore";
import AppFileInput from "../../../../app/components/AppFileInput";
import { FormProvider, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { API_REQUEST_FULLFILLED, MESSAGE_FILE_UPLOADED_SCESSFULLY, MESSAGE_PROCESSING_DETAILS } from "../../../../app/utils/constant";
import { ApiRequestStatus } from "../../../../app/enums/apiRequestStatus";
import LoadingComponent from "../../../../app/layout/LoadingComponent";
import { addDocumentAsync, getDocumentsByCreditRecordIdAsync } from "../../../../app/slices/creditsSlice";
import { useParams } from "react-router-dom";
import cpdFormModel from "../../common/cpdFormModel";
import { cpdAddDocumentValidationSchema } from "../../common/cpdAddDocumentValidationSchema";
import UnsavedChangesDialog from "../../../../app/components/UnsavedChangesDialog";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";

export function AddSupportingDocument() {
    const methods = useForm({
        mode: 'all',
        resolver: yupResolver(cpdAddDocumentValidationSchema)
    });
    const { control, watch, trigger, getValues, setValue } = methods;
    const formObj = methods.watch();
    const { creditRecordId } = useParams<{ creditRecordId: string }>();

    const {
        formField: {
            SupportingDocument
        }
    } = cpdFormModel;

    const dispatch = useAppDispatch();
    const { documentsByCreditRecordId, addDocumentStatus } = useAppSelector(state => state.credits);

    const [isDocumentUploadInProgress, setIsDocumentUploadInProgress] = useState(false);

    const populateFileFormData = (file: File) => {
        const formData = new FormData();
        formData.append("CreditRecordId", creditRecordId);
        formData.append("File", file);

        return formData;
    }

    useEffect(() => {
        watch((_, { name, type }) => {
            if (name === SupportingDocument.name && type === 'change') {
                setIsDocumentUploadInProgress(true);
            }
        });
    }, [SupportingDocument.name, watch]);

    const addCpdDocumentAsync = async () => {
        const isStepValid = await trigger();
        if (!isStepValid) trackPortalEvent(portalScreenContext('AddSupportingDocument'), 'ValidationBlocked', { step: undefined });

        if (isStepValid === true) {
            dispatch(addDocumentAsync(populateFileFormData(formObj.SupportingDocument as File))).then((response: any) => {
                if (response.meta.requestStatus.toLowerCase() === API_REQUEST_FULLFILLED) {
                    setIsDocumentUploadInProgress(false);
                    dispatch(getDocumentsByCreditRecordIdAsync(creditRecordId))
                    toast.success(MESSAGE_FILE_UPLOADED_SCESSFULLY);
                };
            });
        }
    }

    const cpdDocumentUploadFilter = () => {
        const file = getValues(SupportingDocument.name) as File;
        if (!file) {
            return false;
        }
        return documentsByCreditRecordId &&
            documentsByCreditRecordId.some(x => x.name?.trim() === file.name.trim());
    }

    usePortalScreen(portalScreenContext('AddSupportingDocument'), undefined, !((addDocumentStatus === ApiRequestStatus.Pending)));

    if (addDocumentStatus === ApiRequestStatus.Pending) {
        return <LoadingComponent message={MESSAGE_PROCESSING_DETAILS} />
    }

    return <FormProvider {...methods}>
        <Grid container rowSpacing={4}>
            <Grid size={{ xs: 12 }}></Grid>

            <Grid size={{ xs: 4, sm: 3 }}>
                <b>Supporting Document*</b>
            </Grid>

            <Grid size={{ xs: 8, sm: 9 }}>
                <AppFileInput control={control} label={""} name={SupportingDocument.name} />
            </Grid>

            <Grid size={{ xs: 4, sm: 3 }}></Grid>

            <Grid size={{ xs: 8, sm: 9 }}>
                <Button variant="contained" component="span" onClick={portalAction(portalScreenContext('AddSupportingDocument'), 'AddSupportingDocument.onClick.addCpdDocumentAsync', addCpdDocumentAsync)}>
                    Add This Document
                </Button>
            </Grid>

        </Grid>

        {isDocumentUploadInProgress === true && cpdDocumentUploadFilter() === true &&
            <UnsavedChangesDialog showDialog={true}
                title={'Duplicate file found.'}
                subTitle={`The file you are uploading is already in the system. 
                    Please rename the file and upload again.`}
                skipButtonClick={portalAction(portalScreenContext('AddSupportingDocument'), 'AddSupportingDocument.skipButtonClick.setValue', () => {
                    setValue(SupportingDocument.name, undefined);
                    setIsDocumentUploadInProgress(false);
                    trigger();
                })}
                showYesNoButtons={false} />
        }
    </FormProvider>
}
